<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  [styleClass]="data.dialogData.stlClass"
  (onHide)="closeDialog()"
>
  <p-header> {{title}} </p-header>
  <div>
    <p *ngIf="messages.length==1">{{messages[0]}}</p>
    <p *ngIf="messages.length==1 && subMessage!=null">{{subMessage}}</p>

    <ul *ngIf="messages.length>1" class="fa-ul">
      <li *ngFor="let message of messages"><i class="fa-li fa icon-warning"></i>{{message}}</li>
    </ul>
  </div>

  <p-footer
    class="dialog__footer__confirm"
    fxLayout="row"
    fxLayoutGap="4px"
    fxLayoutAlign="end center"
  >
    <button
      *ngIf="cancelLabel != null"
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="{{cancelLabel}}"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionConfirmed()"
      label="{{okLabel}}"
    ></button>
  </p-footer>
</p-dialog>
